/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateExperimentRunRequest
 */
export interface UpdateExperimentRunRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateExperimentRunRequest
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateExperimentRunRequest
   */
  purpose?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateExperimentRunRequest
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the UpdateExperimentRunRequest interface.
 */
export function instanceOfUpdateExperimentRunRequest(
  value: object,
): value is UpdateExperimentRunRequest {
  return true;
}

export function UpdateExperimentRunRequestFromJSON(
  json: any,
): UpdateExperimentRunRequest {
  return UpdateExperimentRunRequestFromJSONTyped(json, false);
}

export function UpdateExperimentRunRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateExperimentRunRequest {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    purpose: json["purpose"] == null ? undefined : json["purpose"],
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function UpdateExperimentRunRequestToJSON(
  json: any,
): UpdateExperimentRunRequest {
  return UpdateExperimentRunRequestToJSONTyped(json, false);
}

export function UpdateExperimentRunRequestToJSONTyped(
  value?: UpdateExperimentRunRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    purpose: value["purpose"],
    notes: value["notes"],
  };
}
